import React, { FunctionComponent, useState, useEffect } from "react";
import styles from "./MainComponent.module.css";


interface Message {
  id: number;
  content: string;
}

interface MainComponentProps {
  userMessages: Message[];
  gptResponse?: string;
}

const MainComponent: FunctionComponent<MainComponentProps> = ({ userMessages, gptResponse }) => {

  return (
    <main className={styles.ans2Parent}>
      <div className={styles.ans2}>
        <div className={styles.ans}>
          <p className={styles.gptContainer}>
            <span className={styles.span}>{`어서오세요! `}</span>
            <span className={styles.span}>&nbsp;</span>
            <span className={styles.span}>{`요금제 GPT가 여러분의 알뜰 요금제 선택을 더욱 쉽고 편리하도록 도와드리겠습니다. `}</span>
            <span className={styles.span}>&nbsp;</span>
            <span className={styles.span}>{`원하시는 요금제의 조건이나 현재 사용 중인 요금제의 불편한 점을 채팅으로 알려주세요. `}</span>
            <span className={styles.span}>{`예시: "나는 하루에 1시간 통화하는 것  같고 유튜브를 많이 보는 편이야. 가격이 적당하면서도 통화량 가성비 좋은 거 없을까?"`}</span>
            <span className={styles.span}>AI가 여러분의 필요에 가장 잘 맞는 요금제를 찾아드리겠습니다.</span>
          </p>
        </div>
      </div>
      {userMessages.map((message) => (
        <div className={styles.que2} key={message.id}>
          <div className={styles.que}>
            <p className={styles.p}>{message.content}</p>
          </div>
        </div>
      ))}
      {gptResponse && (
    <main className={styles.ans2Parent}>
    <div className={styles.ans2}>
      <div className={styles.ans}>
          <p className={styles.gptContainer}>{gptResponse}</p>
        </div>
        </div>
        </main>
      )}
    </main>
  );
};

export default MainComponent;
